/**
 * ProdutosPendentesWidget — Produtos pendentes de cadastro pelo estoque
 * (auto-criados pelo import CAD; vendedor nao envia orcamento ate cadastro).
 */
import React from "react";
import { Link } from "react-router-dom";

import { listarProdutos } from "../../../services/estoque";

import { CardBody, KpiValor, KpiSub, LinkLight, CardFooter } from "../styles";


export const meta = {
  id: "produtos_pendentes",
  label: "Produtos pendentes",
  descricao: "Produtos auto-criados pelo CAD que esperam cadastro de preco.",
  categoria: "Pendencias",
  permissoes: ["estoque:edit_produto"],
  tamanho_default: "S",
  essencial: true,
};

export async function fetchData(request) {
  const payload = await listarProdutos(request, { pendente: true, pageSize: 1 });
  const c = Array.isArray(payload) ? payload.length : (payload?.count ?? (payload?.results || []).length);
  return { pendentes: c };
}

export function Widget({ dados }) {
  const c = dados?.pendentes ?? 0;
  return (
    <>
      <CardBody>
        <KpiValor style={{ color: c > 0 ? "var(--warning-text)" : undefined }}>{c}</KpiValor>
        <KpiSub>
          {c > 0
            ? "produtos aguardando cadastro de preco"
            : "Nenhum produto pendente."}
        </KpiSub>
      </CardBody>
      <CardFooter>
        <LinkLight as={Link} to="/estoque/pendentes">Ir para fila</LinkLight>
      </CardFooter>
    </>
  );
}
